import { forwardRef } from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export const SectionShell = ({ title, id, viewAllTo, children, className = "" }) => (
  <section id={id} className={`py-5 sm:py-7 ${className}`} data-testid={`section-${id}`}>
    <div className="px-4 sm:px-6 max-w-6xl mx-auto">
      <div className="flex items-end justify-between mb-3 sm:mb-4">
        <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-foreground font-heading">
          {title}
        </h2>
        {viewAllTo && (
          <Link
            to={viewAllTo}
            data-testid={`view-all-${id}`}
            className="flex items-center gap-1 text-sm font-semibold text-primary hover:opacity-80 transition-opacity"
          >
            Ver todas <ChevronRight className="w-4 h-4" />
          </Link>
        )}
      </div>
      {children}
    </div>
  </section>
);

export const Carousel = forwardRef(({ children, className = "", ...rest }, ref) => (
  <div ref={ref} {...rest} className={`flex gap-3 sm:gap-4 overflow-x-auto hide-scrollbar snap-x-mandatory scroll-px-4 sm:scroll-px-0 pb-2 -mx-4 px-4 sm:mx-0 sm:px-0 ${className}`}>
    {children}
  </div>
));
Carousel.displayName = "Carousel";
